import React, { useEffect, useRef, useState } from "react";
import {
    Form,
    Input,
    InputNumber,
    Tooltip,
} from "antd";
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import GenericModal from "../../buttons/genericModal";
import { v4 as uuidv4 } from "uuid";
import { ArrowRightOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import { backendPostWithoutRefresh } from "../../../helpers/callBackend";


function InitiateRequestFunds(props) {
    const [visibleSelectOption, setVisibleSelectOption] = useState(false);
    const [submittingCopyLink, setSubmittingCopyLink] = useState(false);
    const [visibleFillInfo, setVisibleFillInfo] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [formValues, setFormValues] = useState({});
    const [disabled, setDisabled] = useState(false);
    const [spanStyle, setSpanStyle] = useState({ fontWeight: "400", fontSize: "14px", color: "rgba(0,0,0,0.25)" });
    const userPermission = localStorage.getItem("arpariUserPermission");

    const requestFundsFormRef = useRef(null);

    useEffect(() => {
        if (disabled) {
            setSpanStyle({ cursor: "not-allowed", fontWeight: "400", fontSize: "14px", color: "rgba(0,0,0,0.25)" })
        } else {
            setSpanStyle({ fontWeight: "400", fontSize: "14px", color: "#1890ff", cursor: "pointer" })
        }
    }, [disabled])

    useEffect(() => {
        setDisabled(userPermission === "RO" || (props.bankAccountInfo?.has_ach_debit && props.bankAccountInfo.source !== "MA"))
    }, [userPermission])


    const onFormSubmitModal = (copyLink = false) => {
        if (copyLink) {
            setSubmittingCopyLink(true);
        }
        setSubmitting(true);
        let values = { ...formValues };
        if (values["message_to_payee"] === undefined) {
            values["message_to_payee"] = "";
        }
        let data = values;
        data["bank_account_id"] = props.bankAccountId;
        data["idempotency_key"] = uuidv4();
        data["copy_link"] = copyLink;
        backendPostWithoutRefresh(
            "/api/payments/ach-debit/",
            data,
        ).then((response) => {
            props.addAchDebitRequest(response.data.ach_debit_request);
            if (requestFundsFormRef.current) {
                requestFundsFormRef.current.resetFields();
            }
            setVisibleSelectOption(false);
            setSubmittingCopyLink(false);
            setVisibleFillInfo(false);
            setSubmitting(false);
            if (copyLink) {
                navigator.clipboard.writeText(response.data.ach_debit_request.url);
            }
        });
    }

    const askOptionModal = (values) => {
        setFormValues(values);
        setVisibleFillInfo(false);
        setVisibleSelectOption(true);
    }

    return (<>
        <Tooltip title={disabled ? "Request funds not permitted. Please check permission with your admin." : undefined}>
            <span
                disabled={disabled}
                style={spanStyle}
                onClick={() => disabled ? undefined : setVisibleFillInfo(true)}>
                Request Funds <ArrowRightOutlined />
            </span>
        </Tooltip>
        <GenericModal
            size='md'
            visible={visibleFillInfo}
            handleCancelModal={() => {
                if (requestFundsFormRef.current) {
                    requestFundsFormRef.current.resetFields();
                }
                setVisibleFillInfo(false);
            }}
            showModal={() => setVisibleFillInfo(true)}
            modalTitle={`Request New ACH Debit for ${props.bankAccountInfo.account_description}`}
            modalBody={
                <Form
                    layout="vertical"
                    name="basic"
                    onFinish={askOptionModal}
                    autoComplete="off"
                    ref={requestFundsFormRef}
                >
                    <Form.Item
                        label={<label style={{ margin: "5px", marginRight: "13px" }}> Payee Email: </label>}
                        name="payee_email"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                        }}
                        rules={[
                            {
                                required: true,
                                message: "Payee Email is required!",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={<label style={{ margin: "5px", marginRight: "10px" }}> Payee Name: </label>}
                        name="payee_name"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                        }}
                        rules={[
                            {
                                required: true,
                                message: "Payee Name is required!",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={<label style={{ margin: "5px", marginRight: "39px" }}> Amount: </label>}
                        name="amount"
                        rules={[
                            {
                                required: true,
                                message: "Amount is required!",
                            },
                        ]}
                        style={{
                            display: "flex",
                            flexDirection: "row",
                        }}
                    >
                        <InputNumber
                            placeholder="100"
                            formatter={(value) =>
                                `$ ${value}`.replace(
                                    /\B(?=(\d{3})+(?!\d))/g,
                                    ","
                                )
                            }
                            parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, "")
                            }
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<label style={{ margin: "5px", marginRight: "49px" }}> Memo: </label>}
                        name="memo"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                        }}
                        rules={[
                            {
                                required: true,
                                message: "Memo is required!",
                            },
                        ]}
                    >
                        <Input maxLength={10} />
                    </Form.Item>
                    <Form.Item
                        label="Message to Payee:"
                        name="message_to_payee"
                    >
                        <TextArea maxLength={80} />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            htmlType="submit"
                            disabled={submitting}
                            style={{ margin: "3px", width: "20%" }}
                            disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                            sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                        >
                            Next
                        </Button>
                    </Form.Item>
                </Form>
            }
        />
        <GenericModal
            size='sm'
            visible={visibleSelectOption}
            handleCancelModal={() => visibleSelectOption(false)}
            showModal={() => visibleSelectOption(true)}
            modalTitle={'Copy link to clipboard'}
            modalBody={
                <Form
                    layout="vertical"
                    name="basic"
                    autoComplete="off"
                >
                    <Form.Item
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "spaceBetween",
                        }}
                    >
                        {/*
                      <Button
                          type="primary"
                          onClick={() => this.onFormSubmitModal(false)}
                          disabled={this.state.submitting || this.state.submittingCopyLink}
                          style={{
                              margin: "3px",
                              width: "45%",
                          }}
                      >
                          Send Email
                      </Button>
                      */}
                        <Button
                            onClick={() => onFormSubmitModal(true)}
                            disabled={submitting}
                            loading={submittingCopyLink}
                            style={{
                                margin: "3px",
                                marginLeft: "10px",
                                width: "45%",
                            }}
                            disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                            sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                        >
                            Copy Link
                        </Button>
                    </Form.Item>
                </Form>
            }
        />
    </>
    );
}

export default InitiateRequestFunds;
